module.exports = __webpack_public_path__ + "static/media/setupWarningNew.d4636672.svg";